<!-- @format -->

<template>
	<div id="app">
		<app-nav v-if="loggedIn"/>
		<NotificationContainer />
		<div class="lc-main-container" :class="{'lc-landing-page-container': !loggedIn}">
			<router-view class="page" />
		</div>
	</div>
</template>

<script>
import AppNav from './components/AppNav';
import NotificationContainer from '@/components/NotificationContainer.vue'
import {authComputed} from './store/helpers.js';
export default {
	components: {AppNav, NotificationContainer},
	computed: {
		...authComputed
	},
};
</script>

<style lang="scss">
@import './assets/styles/global.scss';

</style>
